/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Type_Heating_ProfileInputs */



/**
* | output |
* | --- |
* | "Heating profile" |
*
* @param {Entity_Type_Heating_ProfileInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const entity_type_heating_profile = /** @type {((inputs?: Entity_Type_Heating_ProfileInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Type_Heating_ProfileInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Heating profile")
	return /** @type {LocalizedString} */ ("Profil de chauffe")
});